import DEFINE, { PATHS } from "./../constants/Define";

export default [
  {
    title: "websites",
    tagSub: "websites",
    exact: false,
    path: "websites",
    show: true,
    icon: "home",
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.WEBSITE,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
      {
        title: "banners",
        group: "banners",
        tagSub: "websites",
        path: PATHS.BANNER.LIST.path,
        exact: false,
        icon: "picture",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.BANNER,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
        children: [
          {
            title: "createBanners",
            group: "banners",
            tagSub: "websites",
            path: "/banners/action",
            exact: false,
            icon: "user",
            show: false,
          },
          {
            title: "updateBanners",
            group: "banners",
            tagSub: "websites",
            path: "/banners/action/:id",
            exact: false,
            icon: "user",
            show: false,
          },
        ],
      },
      {
        title: "categories",
        group: "categories",
        tagSub: "websites",
        path: PATHS.CATEGORY.LIST.path,
        exact: false,
        icon: "align-left",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.CATEGORY,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
        children: [
          {
            title: "createCategories",
            group: "categories",
            tagSub: "websites",
            path: PATHS.CATEGORY.CREATE.path,
            exact: false,
            icon: "align-left",
            show: false,
          },
          {
            title: "updateCategories",
            group: "categories",
            tagSub: "websites",
            path: PATHS.CATEGORY.DETAIL.path,
            exact: false,
            icon: "align-left",
            show: false,
          },
        ],
      },
      {
        title: "pages",
        group: "pages",
        tagSub: "websites",
        path: PATHS.PAGE.LIST.path,
        exact: false,
        icon: "copy",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.PAGE,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
        children: [
          {
            title: "createPages",
            group: "pages",
            tagSub: "websites",
            path: PATHS.PAGE.CREATE.path,
            exact: false,
            icon: "copy",
            show: false,
          },
          {
            title: "updatePages",
            group: "pages",
            tagSub: "websites",
            path: PATHS.PAGE.DETAIL.path,
            exact: false,
            icon: "copy",
            show: false,
          },
        ],
      },
      {
        title: "posts",
        group: "posts",
        tagSub: "websites",
        path: PATHS.POST.LIST.path,
        exact: false,
        icon: "edit",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.POST,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
        children: [
          {
            title: "createPosts",
            group: "posts",
            tagSub: "websites",
            path: PATHS.POST.CREATE.path,
            exact: false,
            icon: "edit",
            show: false,
          },
          {
            title: "updatePosts",
            group: "posts",
            tagSub: "websites",
            path: PATHS.POST.DETAIL.path,
            exact: false,
            icon: "edit",
            show: false,
          },
        ],
      },
      {
        title: "ratings",
        group: "ratings",
        tagSub: "websites",
        path: PATHS.RATING.LIST.path,
        exact: false,
        icon: "star",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.RATING,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.APPROVE,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
        children: [
          {
            title: "detailRatings",
            group: "ratings",
            tagSub: "websites",
            path: PATHS.RATING.DETAIL.path,
            exact: false,
            icon: "edit",
            show: false,
          },
        ],
      },
      {
        title: "siteInfos",
        group: "siteInfos",
        tagSub: "websites",
        path: PATHS.SITEINFO.LIST.path,
        exact: false,
        icon: "info-circle",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.SITEINFO,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
        children: [
          {
            title: "createSiteInfos",
            group: "siteInfos",
            tagSub: "websites",
            path: PATHS.SITEINFO.CREATE.path,
            exact: false,
            icon: "",
            show: false,
          },
          {
            title: "updateSiteInfos",
            group: "siteInfos",
            tagSub: "websites",
            path: PATHS.SITEINFO.DETAIL.path,
            exact: false,
            icon: "",
            show: false,
          },
        ],
      },
      {
        title: "tagGroupDetails",
        group: "tagGroupDetails",
        tagSub: "websites",
        path: PATHS.TAG_GROUP_DETAIL.LIST.path,
        exact: false,
        icon: "tags",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.TAG_GROUP_DETAIL,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
          DEFINE.GENERAL.PERMISSION.MAP_SKU,
        ],
        children: [
          {
            title: "createTagGroupDetails",
            group: "tagGroupDetails",
            tagSub: "websites",
            path: PATHS.TAG_GROUP_DETAIL.CREATE.path,
            exact: false,
            icon: "",
            show: false,
          },
          {
            title: "updateTagGroupDetails",
            group: "tagGroupDetails",
            tagSub: "websites",
            path: PATHS.TAG_GROUP_DETAIL.DETAIL.path,
            exact: false,
            icon: "",
            show: false,
          },
          {
            title: "linkSkuTagGroupDetails",
            group: "tagGroupDetails",
            tagSub: "websites",
            path: PATHS.TAG_GROUP_DETAIL.DETAIL.LINK_SKU.path,
            exact: false,
            icon: "",
            show: false,
          },
        ],
      },
      {
        title: "productFeed",
        group: "productFeed",
        tagSub: "websites",
        path: PATHS.PRODUCT_FEED.EXPORT.path,
        exact: false,
        icon: "faFileExport",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.PRODUCT_FEED,
        permissions: [
          DEFINE.GENERAL.PERMISSION.EXPORT,
          DEFINE.GENERAL.PERMISSION.VIEW,
        ],
      },
      {
        title: "productReindex",
        group: "productReindex",
        tagSub: "websites",
        path: PATHS.PRODUCT_REINDEX.REINDEX.path,
        exact: false,
        icon: "sync",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.EXPERIENCE,
        permissions: [
          DEFINE.GENERAL.PERMISSION.REINDEX,
          DEFINE.GENERAL.PERMISSION.VIEW,
        ],
      },
      {
        title: "redirectlink",
        group: "redirectlink",
        tagSub: "websites",
        path: PATHS.REDIRECT_LINK.LIST.path,
        exact: false,
        icon: "link",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.REDIRECT_LINK,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.CREATE,
          DEFINE.GENERAL.PERMISSION.UPDATE,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
        children: [
          {
            title: "createRedirectLink",
            group: "redirectlink",
            tagSub: "websites",
            path: PATHS.REDIRECT_LINK.CREATE.path,
            exact: false,
            icon: "link",
            show: false,
          },
          {
            title: "updateRedirectLink",
            group: "redirectlink",
            tagSub: "websites",
            path: PATHS.REDIRECT_LINK.DETAIL.path,
            exact: false,
            icon: "link",
            show: false,
          },
        ],
      },
      {
        title: "recommendation",
        group: "recommendation",
        tagSub: "websites",
        path: PATHS.RECOMMENDATION.path,
        exact: false,
        icon: "copy",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.RECOMMENDATION,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.UPDATE,
        ],
      },
      {
        title: "clearCache",
        group: "clearCache",
        tagSub: "websites",
        path: PATHS.CACHE.path,
        exact: false,
        icon: "stop",
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.CLEAR_CACHE,
        permissions: [
          DEFINE.GENERAL.PERMISSION.VIEW,
          DEFINE.GENERAL.PERMISSION.DELETE,
        ],
      },
    ],
  },
];
